
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { collect, empty, map, append, singleton, delay, toList, iterate } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { map as map_1, defaultArg, filter, ofNullable, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { SearchResultTypeModule_all, minimumQueryLength, SearchMatchFieldModule_key, SearchResultTypeModule_key, SearchResultTypeModule_isInventory } from "../Shared/Search.js";
import Shipping_Box_2 from "../../public/assets/icons/Shipping_Box_2.svg";
import Warehouse_1 from "../../public/assets/icons/Warehouse_1.svg";
import Location_Building_Search from "../../public/assets/icons/Location_Building_Search.svg";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Avatar } from "../Components/Avatar.js";
import { filter as filter_1, choose, empty as empty_1, isEmpty, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import swr from "swr";
import { fetchSearch, searchUrl } from "../Requests/Search.js";
import { SearchInput } from "../Components/Input.js";
import Magnifying_Glass from "../../public/assets/icons/Magnifying_Glass.svg";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const testId = "top-navigation-search";

const inputId = concat(testId, ..."-input-test-id");

const debounceMilliseconds = 300;

function route(currentUserId, canReadUsers, result) {
    const matchValue = result.Type;
    switch (matchValue) {
        case "tool":
            return ["tools", result.Id];
        case "toolWithQuantity":
            return ["toolswithquantity", result.Id];
        case "consumable":
            return ["consumables", result.Id];
        case "set":
            return ["sets", result.Id];
        case "employee":
            return ["receivers", "employees", result.Id];
        case "externalPerson":
            return ["receivers", "external-persons", result.Id];
        case "subcontractor":
            return ["receivers", "subcontractors", result.Id];
        case "room":
            return ["receivers", "rooms", result.Id];
        case "project":
            return ["receivers", "projects", result.Id];
        case "constructionSite":
            return ["receivers", "construction-sites", result.Id];
        case "student":
            return ["receivers", "students", result.Id];
        case "schoolClass":
            return ["receivers", "school-classes", result.Id];
        case "vehicle":
            return ["receivers", "vehicles", result.Id];
        case "storage":
            return ["storages", result.Id];
        case "location":
            return ["locations", result.Id];
        default:
            if ((result.Id === currentUserId) && !canReadUsers) {
                return ["profile"];
            }
            else {
                return ["receivers", "users", result.Id];
            }
    }
}

function focusInput() {
    iterate((element) => {
        element.focus();
    }, toArray(ofNullable(document.getElementById(inputId))));
}

function ResultImage(props) {
    let elems_1;
    const placeholderIcon = SearchResultTypeModule_isInventory(props.Result.Type) ? Shipping_Box_2() : ((props.Result.Type === "storage") ? Warehouse_1() : ((props.Result.Type === "location") ? Location_Building_Search() : undefined));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["shrink-0", "h-10", "w-10"])], (elems_1 = toList(delay(() => {
        if (props.Result.ImageUrl !== "") {
            return singleton(reactElement("img", {
                src: props.Result.ImageUrl,
                alt: "",
                className: join(" ", ["h-10", "w-10", "rounded-lg", "object-cover", "bg-background"]),
            }));
        }
        else {
            const matchValue = placeholderIcon;
            if (matchValue == null) {
                return singleton(createElement(Avatar, {
                    Id: props.Result.Id,
                    Name: props.Result.Title,
                    Size: 40,
                }));
            }
            else {
                const icon = matchValue;
                return singleton(reactElement("div", {
                    className: join(" ", ["h-10", "w-10", "rounded-lg", "bg-background", "text-text-muted", "flex", "items-center", "justify-center", "p-2"]),
                    children: reactApi.Children.toArray([icon]),
                }));
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ResultGroup(props) {
    let elems_7;
    const t = useTranslation()[0];
    const typeKey = SearchResultTypeModule_key(props.Type);
    return reactElement("div", createObj(ofArray([["data-test-id", concat("global-search-group-", ...typeKey)], ["className", join(" ", ["mb-2"])], (elems_7 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["px-3", "pt-2", "pb-1", "text-sm", "font-bold", "text-black"]),
        children: t(concat("global_search.group.", ...typeKey)),
    })), delay(() => map((result) => {
        let elems_6, elems_5, elems_4;
        return reactElement("div", createObj(ofArray([["key", concat(typeKey, "-", ...result.Id)], ["data-test-id", concat("global-search-result-", typeKey, "-", ...result.Id)], ["className", join(" ", ["px-3", "py-2", "rounded-lg", "cursor-pointer", "hover:bg-background"])], ["onClick", (_arg) => {
            props.OnSelect(result);
        }], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3"])], (elems_5 = [createElement(ResultImage, {
            Result: result,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-0"])], (elems_4 = toList(delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "truncate"]),
            children: result.Title,
        })), delay(() => append((result.Subtitle !== "") ? singleton(reactElement("div", {
            className: join(" ", ["text-xs", "text-text-muted", "truncate"]),
            children: result.Subtitle,
        })) : empty(), delay(() => {
            let elems_1;
            return append(!isEmpty(result.Matches) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-1", "mt-1"])], (elems_1 = toList(delay(() => collect((matched) => {
                let elems;
                const fieldKey = SearchMatchFieldModule_key(matched.Field);
                return singleton(reactElement("div", createObj(ofArray([["key", concat(fieldKey, "-", ...matched.Value)], ["data-test-id", `global-search-result-${typeKey}-${result.Id}-match-${fieldKey}`], ["className", join(" ", ["text-[11px]", "rounded", "bg-background", "px-1.5", "py-0.5", "text-text-muted", "truncate", "max-w-full"])], (elems = [reactElement("span", {
                    className: join(" ", ["font-semibold"]),
                    children: t(concat("global_search.field.", ...fieldKey)),
                }), reactElement("span", {
                    children: concat(" ", ...matched.Value),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }, result.Matches))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty(), delay(() => {
                let elems_3, elems_2;
                return (result.StorageName !== "") ? singleton(reactElement("div", createObj(ofArray([["data-test-id", `global-search-result-${typeKey}-${result.Id}-storage`], ["className", join(" ", ["text-xs", "text-text-muted", "truncate", "flex", "items-center", "gap-1"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-3", "w-3", "shrink-0"])], (elems_2 = [Warehouse_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("span", {
                    children: result.StorageName,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
            }));
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
    }, props.Results))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function GlobalSearch(props) {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const setQuery = patternInput_1[1];
    const query = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const debouncedQuery = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsOpen = patternInput_3[1];
    const container = reactApi.useRef(undefined);
    useEffectWithDeps(() => {
        const handle = window.setTimeout((_arg) => {
            patternInput_2[1](query.trim());
        }, debounceMilliseconds);
        return createDisposable(() => {
            window.clearTimeout(handle);
        });
    }, [query]);
    useEffectWithDeps(() => {
        const onMouseDown = (event) => {
            let element;
            const matchValue = container.current;
            let matchResult, element_1;
            if (matchValue != null) {
                if ((element = matchValue, !element.contains(event.target))) {
                    matchResult = 0;
                    element_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    setIsOpen(false);
                    break;
                }
                case 1: {
                    break;
                }
            }
        };
        const onKeyDown = (event_1) => {
            const keyboardEvent = event_1;
            if ((keyboardEvent.ctrlKey ? true : keyboardEvent.metaKey) && (keyboardEvent.key.toLocaleLowerCase() === "k")) {
                keyboardEvent.preventDefault();
                focusInput();
                setIsOpen(true);
            }
        };
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("keydown", onKeyDown);
        return createDisposable(() => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("keydown", onKeyDown);
        });
    }, []);
    const trimmedQuery = query.trim();
    const isQueryLongEnough = trimmedQuery.length >= minimumQueryLength;
    const isDebouncedQueryLongEnough = debouncedQuery.length >= minimumQueryLength;
    const response = swr(isDebouncedQueryLongEnough ? searchUrl(debouncedQuery) : defaultOf(), fetchSearch, {
        keepPreviousData: true,
        revalidateOnFocus: false,
    });
    const currentResponse = filter((data) => {
        if (isDebouncedQueryLongEnough && (debouncedQuery === trimmedQuery)) {
            return data.Query === debouncedQuery;
        }
        else {
            return false;
        }
    }, response.data);
    const results = defaultArg(map_1((_arg_1) => _arg_1.Results, currentResponse), empty_1());
    const hasFailed = (isDebouncedQueryLongEnough && (debouncedQuery === trimmedQuery)) && (response.error != null);
    const isLoading = (isQueryLongEnough && (currentResponse == null)) && !hasFailed;
    const groups = choose((resultType) => {
        const matchValue_1 = filter_1((result_1) => (result_1.Type === resultType), results);
        if (isEmpty(matchValue_1)) {
            return undefined;
        }
        else {
            return [resultType, matchValue_1];
        }
    }, SearchResultTypeModule_all);
    return reactElement("div", createObj(ofArray([["data-test-id", "global-search"], ["ref", container], ["className", join(" ", ["relative", "w-80", "min-w-[12rem]", "shrink", "mx-5"])], ["onFocus", (_arg_2) => {
        setIsOpen(true);
    }], ["onKeyDown", (keyboardEvent_1) => {
        if (keyboardEvent_1.key === "Escape") {
            setIsOpen(false);
        }
    }], (elems_1 = toList(delay(() => {
        let Placeholder;
        return append(singleton(createElement(SearchInput, (Placeholder = t("global_search.placeholder"), {
            ComponentState: "enabled",
            LeftIcon: Magnifying_Glass(),
            OnChange: (value_7) => {
                setQuery(value_7);
                setIsOpen(true);
            },
            Placeholder: Placeholder,
            TestId: testId,
            Value: query,
        }))), delay(() => {
            let elems;
            return (patternInput_3[0] && isQueryLongEnough) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "global-search-results"], ["className", join(" ", ["absolute", "right-0", "top-12", "w-[32rem]", "max-h-[70vh]", "overflow-y-auto", "bg-white", "rounded-lg", "border", "border-border", "drop-shadow-xl", "z-50", "p-2"])], (elems = toList(delay(() => {
                let arg_1;
                return isEmpty(groups) ? (hasFailed ? singleton(reactElement("div", {
                    "data-test-id": "global-search-error",
                    className: join(" ", ["px-3", "py-2", "text-sm", "text-red"]),
                    children: t("global_search.error"),
                })) : (isLoading ? singleton(reactElement("div", {
                    "data-test-id": "global-search-loading",
                    className: join(" ", ["px-3", "py-2", "text-sm", "text-text-muted"]),
                    children: t("global_search.loading"),
                })) : singleton(reactElement("div", {
                    "data-test-id": "global-search-no-results",
                    className: join(" ", ["px-3", "py-2", "text-sm", "text-text-muted"]),
                    children: (arg_1 = {
                        query: trimmedQuery,
                    }, patternInput[1].t("global_search.no_results", arg_1)),
                })))) : collect((matchValue_2) => singleton(createElement(ResultGroup, {
                    OnSelect: (result) => {
                        setIsOpen(false);
                        setQuery("");
                        RouterModule_nav(ofArray(route(props.CurrentUserId, props.CanReadUsers, result)), 1, 1);
                    },
                    Results: matchValue_2[1],
                    Type: matchValue_2[0],
                })), groups);
            })), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

